module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAWCAYAAAAfD8YZAAAA6UlEQVQ4T+2UsU4CQRiEv0nufAkKG3gCC0swMXbQEWpjaW3LA5jwClDZ2EEsMCaEg0YTC16AwkIKauhOhmwnHiR32LLVZmfnn80/s788jm+RuxRdoi0n0StwU5QLTOVJ9Ia5Ru7lLmC1gFlQ/gQuVE2Vl+wk/oLNTyC/A5fFyNE3sDqRc7bbyalhRyfs2GxvQjxHwBXobscpcYZ9jrVArHdddAeYy5P4Gbt5wOLwAUoHsEFQ7gONzAXzolpa9zh6RDxkcDH89ewMvMQ8IddB5T3qH/rXDAsVncT34ErY/lEI0yV7ZhYs084WLV2kZdWC+o8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 21